const initialState = {
    FBRProductList: [],
    FBRProductDataList: [],
    isFetchingFBRProduct: false,
    isAddingFBRProduct: false,
};

const FBRProductReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_ADD_FBR_PRODUCT":
            return { ...state, isAddingFBRProduct: true };
        case "SUCCESS_ADD_FBR_PRODUCT":
            return { ...state, FBRProductList: action.payload, isAddingFBRProduct: false, };
        case "ERROR_ADD_FBR_PRODUCT":
            return { ...state, isAddingFBRProduct: false };


        case "REQUEST_GET_FBR_PRODUCT":
            return { ...state, isFetchingFBRProduct: true };
        case "SUCCESS_GET_FBR_PRODUCT":
            return { ...state, FBRProductDataList: action.payload.data, isFetchingFBRProduct: false, };
        case "ERROR_GET_FBR_PRODUCT":
            return { ...state, };


        default:
            return state;
    }
};
export default FBRProductReducer;